import { CgCloseO } from 'react-icons/cg';
import { FaPrint, FaCheck } from 'react-icons/fa';
import {
  HiOutlineDocumentDuplicate as Copy,
  HiOutlinePencilAlt as Edit,
  HiOutlineTrash as Trash,
  HiOutlineChevronDown as ArrowDown,
} from 'react-icons/hi';
import styled, { css } from 'styled-components';

import { ReactComponent as AddListIcon } from 'assets/icons/add-solid.svg';
// import { ReactComponent as ArrowDown } from 'assets/icons/cheveron-down.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

export const iconStyle = css`
  cursor: pointer;
  height: 2rem;
  width: 2rem;
  color: ${(props) => props.theme.special};
  :hover {
    fill: ${(props) => props.theme.gray};
  }
`;

export const reactIconStyle = css`
  cursor: pointer;
  height: 24px;
  width: 24px;
  color: ${(props) => props.theme.special};
  :hover {
    color: ${(props) => props.theme.gray};
  }
`;

export const svgStyle = css`
  position: absolute;
  top: 50%;
  right: 1.5rem;
  transform: translateY(-40%);
`;

export const InputRightIcon = styled.div`
  ${svgStyle};
`;

export const EditIcon = styled(Edit)`
  ${reactIconStyle};
`;
export const PrintIcon = styled(FaPrint)`
  ${iconStyle};
`;
export const CheckIcon = styled(FaCheck)`
  margin-left: 1.5rem;
  ${iconStyle};
`;
export const DeleteIcon = styled(Trash)`
  ${reactIconStyle};
  color: ${({ theme }) => `${theme.error}CC !important`};
  :hover {
    fill: none;
  }
`;

export const StyledArrowDown = styled(ArrowDown)`
  ${reactIconStyle};
`;

export const CopyIcon = styled(Copy)`
  ${reactIconStyle};
`;

export const StyledCloseIcon = styled(CgCloseO)`
  ${iconStyle};
  fill: ${({ theme }) => `${theme.error}CC`};
  color: ${({ theme }) => `${theme.error}CC`};
  :hover {
    fill: ${({ theme }) => theme.error};
    color: ${({ theme }) => theme.error};
  }
`;

export const AddIcon = styled(AddListIcon)`
  ${iconStyle};
  margin-left: 0.5rem;
  cursor: pointer;
  fill: ${(props) => `${props.theme.special}CC`};
  :hover {
    fill: ${(props) => props.theme.special};
  }
`;
